import * as React from "react";
import { Show, SimpleShowLayout, TextField, UrlField, FunctionField, useRecordContext, Link } from 'react-admin';
const AdminUserIDFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/adminuser?filter={"q":"${record.id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}
const AdminUserIDUpdateFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/adminuser?filter={"q":"${record.id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}
const RaiseTicketDetail = ({ ...props }) => (

    <Show title="Raise Ticket" {...props}>
        <SimpleShowLayout>
            <TextField source="profile_id" label="Profile Id" />
            <TextField source="user.name" label="Name" />

            <TextField source="email" label="Email" />
            <TextField source="whatsapp" label="WhatsApp" />
            <TextField source="title" label="Title" />
            <TextField source="category" label="Category" />
            <TextField source="commends" label="Approve Commends" />
            <TextField source="decline_reason" label="Decline Reason" />
            <FunctionField source="status" label="Status" render={record => {
                if (record['status'] === 'Reject') {
                    return (<span style={{ color: 'red' }}>Reject</span>)
                } else if (record['status'] === 'Pending') {
                    return (<span style={{ color: 'orange' }}>Pending</span>)
                } else {
                    return (<span style={{ color: 'green' }}>Approved</span>)
                }
            }} />
            <TextField source='description' label="Description" />
            <TextField source="approvedby.name" label="Approved By" />
            <TextField source="rejactedby.name" label="Rejacted By" />
            <TextField source="approved_at" label="Approved Date" />
            <TextField source="rejected_at" label="Rejected Date" />
        </SimpleShowLayout>
    </Show>
);
export default RaiseTicketDetail